import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { QrCodeIcon, CloseIcon } from '../components/Icons.jsx';

/** Fullscreen scan-to-join view — big QR + big PIN, readable from the back. */
export default function QrStage({ roomCode, onClose }) {
  const joinUrl = `${window.location.origin}/join/${roomCode}`;
  return (
    <div className="qr-stage" onClick={onClose}>
      <button className="qr-stage-close" onClick={onClose} aria-label="ปิด">
        <CloseIcon size={22} />
      </button>
      <div className="qr-stage-inner" onClick={(e) => e.stopPropagation()}>
        <div className="qr-stage-code">
          <QRCodeSVG
            value={joinUrl}
            size={360}
            bgColor="#ffffff"
            fgColor="#16203a"
            level="Q"
            style={{ width: '100%', height: 'auto', display: 'block' }}
          />
        </div>
        <div className="qr-stage-detail">
          <span className="qr-stage-kicker">
            <QrCodeIcon size={16} /> สแกนเพื่อเข้าเรียน
          </span>
          <div className="qr-stage-pin">
            <span className="qr-stage-pin-label">รหัสเข้าเรียน</span>
            <span className="qr-stage-pin-value num">{roomCode}</span>
          </div>
          <p className="qr-stage-alt">
            หรือเปิด <strong>{window.location.host}/join</strong> แล้วกรอกรหัส
          </p>
        </div>
      </div>
    </div>
  );
}
